import React from 'react';
import { NextPageWithLayout } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import extractFromContext from '@helpers/utils/extract-from-context';
import { useTranslation } from 'next-i18next';
import Script from 'next/script';
import { useRouter } from 'next/router';
import DefaultLayout from '@layouts/default-layout';
import StaticPagesLayout from '@layouts/static-pages-layout/static-pages-layout';
import { getAppInitialProps } from '@helpers/initial-props';
import { AvailableLocales } from '@interfaces/models/locale';

const getAccessibilityStatementScriptLang = (locale?: AvailableLocales): string =>
  locale?.split('-')[0]?.toLowerCase() ?? 'en';

const AccessibilityStatementPage: NextPageWithLayout = () => {
  const { t } = useTranslation('accessibility-statement');
  const router = useRouter();
  const scriptLang = getAccessibilityStatementScriptLang(router.locale as AvailableLocales | undefined);

  return (
    <>
      <h1>{t('STATIC_PAGES.ACCESSIBILITY_STATEMENT.PAGE_TITLE')}</h1>
      <div id="a42AccessibilityStatement" />
      <Script
        src={`https://a42cdn.usablenet.com/a42/vestiairecollective/default/prod/accessibilitystatement.js?l=2&lang=${scriptLang}`}
      />
    </>
  );
};

AccessibilityStatementPage.Layout = [DefaultLayout, StaticPagesLayout];
AccessibilityStatementPage.PageType = 'AccessibilityStatementPage';

export const getServerSideProps = async (context) => {
  const { locale } = extractFromContext(context);
  const initialProps = await getAppInitialProps(context);
  const translations = await serverSideTranslations(locale, [
    'default-layout',
    'vc-authentication',
    'accessibility-statement',
    'common',
    'a11y',
  ]);
  return {
    props: {
      ...initialProps,
      ...translations,
    },
  };
};

export default AccessibilityStatementPage;
